import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-global-teams-custom-brand',
  imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './global-teams-custom-brand.html',
  styleUrl: './global-teams-custom-brand.scss',
})
export class GlobalTeamsCustomBrand {

}
